import { useParams } from 'react-router';
import { isObjectId } from '@/lib/dutyAnalytics';
import NotFoundPage from '@/pages/NotFound';
import DutyAnalyticsPage from './index';

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [P7C.1 §4] `/duty-analytics/divisions/:divisionId` — A DIVISION'S OWN PAGE, READ FROM THE COMMISSIONERATE.
 *
 *  ⚠️ ITS OWN ROUTE ELEMENT, AND THE PAGE KEYED BY THE DIVISION — MEASURED: react-router 8.3.0 renders a matched
 *  route with no key. Were this route's element the page itself, the commissionerate's page and a division's would
 *  be one component instance at one position, sharing its `keepPreviousData` observer — so each would paint the
 *  other's figures under its own URL until its answer landed. A different element type remounts on the way in,
 *  and the key remounts between two divisions.
 *
 *  ⚠️ A MALFORMED ID IS NOT FOUND AND ASKS NOTHING (`DashboardTile`'s rule). Whether a well-formed one is a division
 *  the caller may read is the SERVER's question — it answers by POSITION, with one 404 body for every refusal, and
 *  a division-level caller is refused for every id, their own included.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
const DivisionAnalyticsRoute = () => {
  const { divisionId = '' } = useParams();
  if (!isObjectId(divisionId)) return <NotFoundPage />;
  return <DutyAnalyticsPage key={divisionId} asDivisionId={divisionId} />;
};

export default DivisionAnalyticsRoute;
